import React, { createContext, useState, useContext } from "react";

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [selectedCompany, setSelectedCompany] = useState(null);

  return (
    <CompanyContext.Provider value={{ 
      selectedCompany, 
      setSelectedCompany,
      companyId: selectedCompany?.id || selectedCompany?.company_id || null,
      api_key: selectedCompany?.api_key || null
    }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("useCompany must be used within a CompanyProvider");
  }
  return context;
};
